/**
 * Tanıtım takibi read model (GET /leads/outreach/log, v0.1.169): the contract's shape, re-exported so the screen
 * imports from one place, plus the Turkish words for the queue stages and the campaigns.
 */

import type { OutreachQueueStage } from '@twin/contracts';

export type {
  OutreachLog,
  OutreachLogGroup,
  OutreachLogMail,
  OutreachLogText,
  OutreachQueueStage,
} from '@twin/contracts';
export { OUTREACH_QUEUE_STAGES } from '@twin/contracts';

/** The stage's name on its chip and what it waits for, in Sercan's words. */
export const QUEUE_STAGE_LABELS: Readonly<Record<OutreachQueueStage, { label: string; text: string }>> = Object.freeze({
  scheduled: { label: 'Sırada', text: 'Gönderim saati verildi; iş saatinde gidecek.' },
  approved: { label: 'Onaylandı', text: 'Onayladın; gönderim sırasına girecek.' },
  ready: { label: 'Onayını bekliyor', text: 'Adres ve denetim tamam; Tanıtım gönderimi sayfasında onayını bekliyor.' },
  audit: { label: 'Denetim bekliyor', text: 'Adres tamam; Denetçi bu firmayı henüz denetlemedi.' },
  address: { label: 'Adres kontrolü', text: 'Mail adresi henüz kontrol edilmedi.' },
  brand_wait: {
    label: '14 gün bekliyor',
    text: 'Bu firmaya ilk mail gitti; takip maili 14 gün dolunca, firma cevap vermediyse gider.',
  },
  blocked: { label: 'Durdu', text: 'Adres kullanılamaz ya da gönderim kapısı durdurdu.' },
});

/** v0.1.170: both campaigns are CadGaragePro's; they are told apart by what they offer. */
export const CAMPAIGN_LABELS: Readonly<Record<string, string>> = Object.freeze({
  'CGP-ORTAKLIK': 'İş birliği',
  'CGP-TARAMA': 'CAD dosyaları',
});
